import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { TeluguYearProvider } from './context/TeluguYearContext';
import Layout from './components/Layout';
import GlobalAudioPlayer from './components/GlobalAudioPlayer';
import Home from './pages/Home';
import VatuRegistration from './pages/VatuRegistration';
import ParikshaResult from './pages/ParikshaResult';
import EditProfile from './pages/EditProfile';
import ParishaadhikariView from './pages/ParishaadhikariView';
import PathasalaManagement from './pages/PathasalaManagement';
import Pariksha from './pages/Pariksha';
import PathasalaExamStatus from './pages/PathasalaExamStatus';
import AuthDebug from './pages/AuthDebug';
import ParikshaSyllabus from './pages/ParikshaSyllabus';
import ParikshaadhikariDetails from './pages/ParikshaadhikariDetails';
import Admin from './pages/Admin';
import RegistrationReport from './pages/RegistrationReport';
import PassReport from './pages/PassReport';
import ExaminerAssignments from './pages/ExaminerAssignments';
import PattaIssueReport from './pages/PattaIssueReport';
import PattaGeneration from './pages/PattaGeneration';
import DownloadPatta from './pages/DownloadPatta';
import CertificateVerify from './pages/CertificateVerify';
import PreviousYearExamDetails from './pages/PreviousYearExamDetails';
import PanasalaAntyakshari from './pages/PanasalaAntyakshari';
import AdminSlideshow from './pages/AdminSlideshow';
import AdminAccessManagement from './pages/AdminAccessManagement';
import MemberRegistration from './pages/MemberRegistration';
import MemberManagement from './pages/MemberManagement';
import RegistrationsView from './pages/RegistrationsView';
import HomepageSlideshowConfig from './pages/HomepageSlideshowConfig';

const appTheme = createTheme({
  palette: {
    primary: {
      main: '#d9672b',
      dark: '#b85a28',
      contrastText: '#fff'
    },
    secondary: {
      main: '#c88a2d',
      dark: '#a96f20',
      contrastText: '#fff'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 800,
          textTransform: 'none',
          letterSpacing: '0.01em',
          transition: 'transform 180ms ease, box-shadow 180ms ease, background 180ms ease',
          background: 'linear-gradient(110deg, #d9672b, #c88a2d)',
          color: '#fff !important',
          boxShadow: '0 5px 12px rgba(201, 112, 43, 0.2)',
          '&:hover': {
            background: 'linear-gradient(110deg, #c85e29, #b97824)',
            color: '#fff !important',
            boxShadow: '0 8px 18px rgba(201, 112, 43, 0.28)',
            transform: 'translateY(-1px)'
          },
          '&.Mui-disabled': {
            color: 'rgba(255,255,255,0.7) !important',
            background: 'linear-gradient(110deg, rgba(217,103,43,0.55), rgba(200,138,45,0.55))',
            boxShadow: 'none'
          }
        }
      }
    }
  }
});

const App = () => {
  return (
    <ThemeProvider theme={appTheme}>
      <AuthProvider>
        <LanguageProvider>
          <TeluguYearProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            {/* Global audio player - persistent across all pages */}
            {/* <GlobalAudioPlayer /> */}
          
          <Routes>
            {/* Slideshow - Full page without sidebar */}
            <Route path="/admin/slideshow" element={<AdminSlideshow />} />
            
            {/* Home page with Layout (header + sidebar) */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
            </Route>
            
            {/* Application pages with Layout */}
            <Route element={<Layout />}>
              <Route path="/pathasalaMgmt" element={<PathasalaManagement />} />
              <Route path="/parikshaMgmt" element={<Pariksha />} />
              <Route path="/member-management" element={<MemberManagement />} />
              <Route path="/registrations-view" element={<RegistrationsView />} />
              <Route path="/member-registration" element={<MemberRegistration />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/registration-report" element={<RegistrationReport />} />
              <Route path="/admin/pass-report" element={<PassReport />} />
              <Route path="/admin/examiner-assignments" element={<ExaminerAssignments />} />
              <Route path="/admin/patta-issue-report" element={<PattaIssueReport />} />
              <Route path="/admin/patta-generation" element={<PattaGeneration />} />
              <Route path="/admin/panasala-antyakshari" element={<PanasalaAntyakshari />} />
              <Route path="/admin/access-management" element={<AdminAccessManagement />} />
              <Route path="/admin/homepage-slideshow" element={<HomepageSlideshowConfig />} />
              <Route path="/admin/previous-year-details" element={<PreviousYearExamDetails />} />
              <Route path="/pathasala-exam-status" element={<PathasalaExamStatus />} />
              <Route path="/download-patta" element={<DownloadPatta />} />
              <Route path="/vatuvu" element={<VatuRegistration />} />
              <Route path="/pariksha-results" element={<ParikshaResult />} />
              <Route path="/pariksha-syllabus" element={<ParikshaSyllabus />} />
              <Route path="/pariksha-adhikaris" element={<ParikshaadhikariDetails />} />
              <Route path="/parishaadhikari" element={<ParishaadhikariView />} />
              <Route path="/edit-profile" element={<EditProfile />} />
              <Route path="/auth-debug" element={<AuthDebug />} />
              <Route path="/verify/:verificationId" element={<CertificateVerify />} />
            </Route>
            </Routes>
          </BrowserRouter>
        </TeluguYearProvider>
      </LanguageProvider>
    </AuthProvider>
    </ThemeProvider>
  );
};

export default App;